<template>
  <div>
    <label class="slds-form-element__label" for="campaign-channel">
      <abbr class="slds-required" title="required" v-if="mode === 'edit' || mode === 'create'">*</abbr>{{ $t('campaignDesigner.targetDefinition.channel') }}
    </label>
    <div class="slds-form-element__control row">
      <div :class="{'has-error' : !valid}">
        <img :src="getIconName(channel)" :class="getClass(channel)" v-for="channel in channels" :key="channel" @click="toggleChannelSelection(channel)"/>
      </div>
    </div>
    <div class="slds-form-element__help error" v-if="!valid">{{ error }}</div>
  </div>
</template>
<script>
import Validator from '../../../../validation/Validator'
export default {
  mixins: [Validator],
  data () {
    return {
      localValue: Array
    }
  },
  created () {
    this.localValue = this.value
  },
  props: {
    channels: Array,
    labelsPrefix: String,
    mode: String,
    value: Array
  },
  methods: {
    toggleChannelSelection (channel) {
      if (this.mode !== 'view') {
        const index = this.localValue.indexOf(channel)
        if (index >= 0) {
          this.localValue.splice(index, 1)
        } else {
          this.localValue.push(channel)
        }

        this.$emit('input', this.localValue)
      }
    },
    getClass (channel) {
      return {
        selected: this.localValue.includes(channel),
        'channel-icon-edit': (this.mode === 'edit' || this.mode === 'create'),
        'channel-icon-view': this.mode === 'view'
      }
    },
    getIconName (iconName) {
      const images = require.context('../../../../assets/icons/standard/', false, /\.png$/)
      return images('./' + iconName + '_60.png')
    }
  },
  watch: {
    value (value) {
      this.clearValidationError()
      this.localValue = value
    }
  }
}
</script>
<style lang="scss" scoped>
.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.channel-icon-view {
  margin-right: 5px;
  height: 32px;
  opacity: 0.5;
  background-color: #4589ee;
  border-radius: 50%;

  &.selected {
    opacity: 1;
  }
}

.has-error {
    border: 1px solid #C23934;
    border-radius: 0.25rem;
}

.error {
  color: #C23934;
}

.channel-icon-edit {
  margin-right: 5px;
  height: 32px;
  opacity: 0.5;
  background-color: #4589ee;
  border-radius: 50%;

  &.selected {
    opacity: 1;
  }

  &:hover {
    opacity: 1;
    cursor: pointer;
  }
}
</style>
